import { HttpErrorResponse, HttpEvent, HttpHeaders, HttpInterceptorFn } from '@angular/common/http';
import { alertaLoaderHTML, refresh } from 'shared-tsi';
import { catchError, EMPTY, map, throwError } from 'rxjs';
import { StorageService } from 'core-tsi';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const sessionInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  let session = StorageService.getSession();
  const token = session && session.token && session.token.length > 5 ? session.token : '';
  const headers = new HttpHeaders({
    'Authorization': token
  })
  const reqClone = req.clone({
    headers
  });

  return next(reqClone).pipe(
    catchError((err: HttpErrorResponse) => {
      const _error = err.error;
      const isBlob = _error instanceof Blob

      const funcionCerrar = () => {
        StorageService.clearStorage();
        refresh()
        router.navigateByUrl(`/login`);
      }

      let html = `<div><img src="../../../../assets/images/logo-tsi-tres.png" class="img-login" ></div>
          <div style="font-size: 1.1rem; font-weight: bolder">
          Ha superado el tiempo límite de inactividad, vuelva a iniciar sesión<div> `;

      if (isBlob && err.status == 401) {
        alertaLoaderHTML(html, 3000, funcionCerrar)
        return EMPTY;
      }

      if (err.status == 401 && _error.message) {
        if (_error.status == 0.9) {
          alertaLoaderHTML(html, 3000, funcionCerrar)
          return EMPTY;
        }

        let _token: string = _error.message.split("=>")[1];
        session = StorageService.getSession();
        if (session) {
          session.correo = 'ftarco',
            session.token = _token.trim();
          StorageService.setAll(session);
        }

        const headers = new HttpHeaders({
          'Authorization': session.token || ''
        })
        const reqClone = req.clone({
          headers
        });
        return next(reqClone)

      }
      return throwError(() => err)
    }),
    map((event: HttpEvent<any>) => {
      return event;
    })
  );
};
